import React, { useState, useEffect, useContext } from "react";
import { Box } from "@mui/material";

import TableStyle from "components/Content/Table/TableStyle.module.css";
import TableAllData from "components/Content/CustomTable/TableAllData";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";

import { Utils } from "common/Utils";

export default function ComplianceReport({ reportData }) {
    const [columnsArray, setColumnsArray] = useState([]);

    useEffect(() => {
        let c = [];

        if (reportData && reportData.headerInfo) {
            if (reportData.report && reportData.report.length > 0) {
                for (var key in reportData.report[0]) {
                    let headerInfo = reportData.headerInfo.find(h => h.name === key);

                    let header = { Header: key, accessor: key};

                    if (headerInfo) {
                        header.Header = headerInfo.header;

                        if (headerInfo.isCurrency) {
                            header.accessor = (cell) => !isNaN(cell[headerInfo.name]) ? <CurrencyFormatter value={cell[headerInfo.name]} /> : null
                        }
                        else if (headerInfo.isDateTime) {
                            header.accessor = (cell) => Utils.formatDate(cell[headerInfo.name]);
                            header.sortType = "dateSort";
                        }
                    }

                    if (reportData.totals[headerInfo.name]) {
                        header.Footer = headerInfo.isCurrency && !isNaN(reportData.totals[headerInfo.name]) ? <CurrencyFormatter value={reportData.totals[headerInfo.name]} /> : reportData.totals[headerInfo.name];
                    }

                    c.push(header);
                }

                setColumnsArray(c);
            }
        }

    },[reportData]);
    
    return (
        <Box>
            {reportData && reportData.report ?
                <TableAllData
                    className={TableStyle.TimeSheetsWrapper}
                    columns={columnsArray}
                    data={reportData.report}
                    doShowBorders={true}
                />
            : null}
        </Box>
    )
}